{
  "id": "campaign-054",
  "name": "Neglected Field",
  "seed": "campaign:54",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,RRRR",
    "zzzz,,,,RRRR",
    ",,,z,,,,____",
    "#,xz,,,,,,,,",
    ",,vvv,,vvv,,",
    ",uvvv,,vvvu,",
    ",,,,,,,,,,..",
    ",u,,y,,y,.u.",
    ",,,,...,,...",
    "ffff..ffffff",
    ",,,....,,,..",
    ",,..y..y,,,,",
    ",,.....,,,,,",
    "ffffffff,,ff",
    "zzzz~~,,,,,,",
    ",,,z,~,,,,,,",
    "..,z,,x,,,,,",
    "S...,,,,,,,,"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 10,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 12
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 54,
  "biome": "farm",
  "par": {
    "reel": 17747,
    "push": 10222,
    "selfPropelled": 9621,
    "tractor": 5665,
    "zeroTurn": 6391,
    "fairway": 4552
  },
  "routeTries": {
    "par": {
      "reel": 2,
      "push": 18,
      "selfPropelled": 20,
      "tractor": 11,
      "zeroTurn": 22,
      "fairway": 9
    }
  }
}
